// Collection fitment filter — applies the site-wide garage vehicle as a native
// Shopify metafield filter (?filter.p.m.titan.fits=...) and shows a "Fits your
// <vehicle>" chip. Tokens mirror scripts/fitment/fits-tokens.ts garageTokens()
// BYTE FOR BYTE:
//   s:<specKey>  t:<thread> (stud) | b:<thread> (hub-bolt)  v:<make|model|year>
// A garage saved before attachmentType existed has none -- default stud.
// The garage stores make/model as slugs already. Applying goes through Horizon's
// facets-form-component.updateFiltersByURL() (AJAX section render — fast, no full
// reload, stacks with the sidebar facets, paginates natively). The fitment facet
// itself is hidden from the sidebar (blocks/filters.liquid); this is its only UI.
(function () {
  var PARAM = "filter.p.m.titan.fits";
  // Filtering on/off comes from the GARAGE now, set by the fitment bar's toggle, so
  // one control governs collections and the gallery alike (RJ, 2026-09-15). It used
  // to be `titan.fits.dismissed`, a key only this page knew about, which meant a
  // shopper had to say "show me everything" once here and again on the gallery.
  //
  // Read from the stored record rather than importing the app block: separate
  // bundles. Absent reads as ON — every garage saved before today.
  var LEGACY_DISMISS_KEY = "titan.fits.dismissed"; // retired — cleared on sight

  function readGarage() {
    try {
      var s = JSON.parse(localStorage.getItem("titan.garage") || "{}");
      if (!s.vehicles) return null;
      return s.vehicles.filter(function (v) { return v.id === s.activeId; })[0] || null;
    } catch (e) { return null; }
  }
  // Lug-centric-only vehicles get a distinct spec token -- mirrors
  // fits-tokens.ts LC_ONLY (derived there from match.ts LUG_CENTRIC_ONLY); kept in
  // lockstep by garage-tokens-parity.test.ts. The Model 3 Performance's hub rejects
  // the hubcentric parts that fit the base Model 3, which shares its spec.
  var LC_ONLY = ["tesla|3|performance"];
  function slug(s) {
    return String(s || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  function garageTokens(v) {
    if (!v) return [];
    var out = [];
    var lcOnly = !!v.submodel && LC_ONLY.indexOf(v.make + "|" + v.model + "|" + slug(v.submodel)) !== -1;
    if (v.specKey) out.push("s:" + v.specKey + (lcOnly ? "|lc" : ""));
    var thread = v.specKey ? v.specKey.split("|")[2] : "";
    if (thread) out.push((v.attachmentType === "bolt" ? "b:" : "t:") + thread);
    if (v.make && v.model && v.year != null && v.year !== "") out.push("v:" + v.make + "|" + v.model + "|" + v.year);
    return out;
  }

  // A VEHICLE BEING ACTIVE IS THE FILTER (RJ, 2026-09-15) — no separate on/off key.
  // The previous flag, and the per-page key before it, both created a state the UI
  // could not express: a vehicle selected but not filtering. Clearing the old key on
  // sight so a half-finished session cannot resurrect it.
  try { sessionStorage.removeItem(LEGACY_DISMISS_KEY); } catch (e) {}

  function dismissed() {
    return false; // kept as a seam; there is nothing to dismiss any more
  }

  function facetsForm() { return document.querySelector("facets-form-component"); }

  // Apply (or clear) the fitment param via Horizon's AJAX filter render, with a
  // full-navigation fallback if the component isn't present.
  // Multiple values must be REPEATED params (?...fits=A&...fits=B) — Shopify ORs
  // those. A comma-joined single value (?...fits=A,B) is treated as one literal
  // value and matches nothing. (Tokens contain ":" and "|" but never ",".)
  function applyParam(tokens) {
    var url = new URL(window.location.href);
    var current = url.searchParams.getAll(PARAM).join(",");
    var next = tokens.join(",");
    if (current === next) return; // no-op — already in the desired state
    url.searchParams.delete(PARAM);
    tokens.forEach(function (t) { url.searchParams.append(PARAM, t); });
    var f = facetsForm();
    if (f && typeof f.updateFiltersByURL === "function") f.updateFiltersByURL(url.toString());
    else window.location.assign(url.toString());
  }

  function chipHost() { return document.querySelector("[data-pl-fitment-chip]"); }
  // Kept in step with pitlane-builds-grid.js and
  // app/extensions/titan-garage/assets/seen-on-builds.js -- separate bundles, no
  // shared module, so app/app/__tests__/esc-parity.test.ts extracts all THREE
  // bodies and asserts they agree.
  //
  // This copy escaped only & < > " and NOT the apostrophe, while the other two
  // escaped all five, and it sat outside the parity test that exists to prevent
  // exactly that. An attribute written with single quotes here would not have been
  // escaped. Pre-launch review R-05 / security L-1.
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  // How many products the filtered grid is actually showing. A vehicle that
  // matches nothing in THIS collection used to render "FITS YOUR 2015 CLUB CAR
  // PRECEDENT" directly above Horizon's "No products found." — the site
  // asserting a fit while showing none of it (pre-flip audit M-02).
  function resultCount() {
    return document.querySelectorAll(".product-grid__item").length;
  }

  function renderChip(vehicle) {
    var host = chipHost();
    if (!host) return;
    if (!vehicle || dismissed()) { host.hidden = true; host.innerHTML = ""; return; }
    if (resultCount() === 0) return renderNoMatch(host, vehicle);
    host.hidden = false;
    // Both sentences are rendered; CSS picks one by width. The long form names
    // the vehicle, which is worth the room on a desktop; the short form gives
    // only the count, because on a phone the bar directly above already says
    // what the shopper drives and repeating it is what got this chip hidden in
    // the first place (2026-09-24).
    var label = esc(vehicle.label || "vehicle");
    var full = (host.getAttribute("data-fit-full") || "").replace("__VEHICLE__", label);
    var short = host.getAttribute("data-fit-short") || "";
    // No server-rendered sentence (an older cached section, say): fall back to
    // what this file has always said rather than rendering an empty chip.
    if (!full) full = "Fits your " + label;
    host.innerHTML =
      '<span class="pl-fitchip">' +
      // STATUS ONLY (RJ, 2026-09-22). Clearing now lives on the fitment bar's ✕,
      // beside the selector it clears; the shopper's real intent there is "let me
      // pick a different vehicle", not "show me everything". Two controls doing
      // the same thing, a screen apart, is what this chip stopped being.
      '<span class="pl-fitchip__label pl-fitchip__label--full">' + full + "</span>" +
      (short ? '<span class="pl-fitchip__label pl-fitchip__label--short">' + short + "</span>" : "") +
      "</span>";
  }

  // Says the true thing, and points at what this vehicle DOES fit. The vehicle
  // stays active: the shopper picked it, and every other collection still needs
  // it (pre-flip audit M-02).
  function renderNoMatch(host, vehicle) {
    var label = esc(vehicle.label || "vehicle");
    // Sentence and destination both come from Liquid: translatable, and pointed
    // at ALL products rather than one collection (RJ, 2026-09-24) — the shopper
    // is already somewhere that has nothing for them, so narrowing again is no
    // help. Fallbacks keep an older cached section rendering something true.
    var out = host.getAttribute("data-shop-all-url") || "/collections/all";
    var said = (host.getAttribute("data-nomatch-label") || "").replace("__VEHICLE__", label) ||
      "Nothing here fits your " + label;
    var cta = (host.getAttribute("data-nomatch-cta") || "").replace("__VEHICLE__", label) ||
      "See what fits your " + label;
    host.hidden = false;
    host.innerHTML =
      '<span class="pl-fitchip pl-fitchip--nomatch">' +
      '<span class="pl-fitchip__label">' + said + "</span>" +
      "</span>" +
      '<a class="pl-fitchip__out" href="' + out + '">' + cta + "</a>";
  }

  // Keep the garage tokens in every facets form as hidden inputs, so a sidebar
  // facet/sort change — which rebuilds the URL from the form — preserves the vehicle.
  // Sourced from the GARAGE, not Shopify's active_values: active_values prunes token
  // values not in the filter's indexed set (e.g. v: with no products), so it would
  // silently drop most of the vehicle's tokens.
  function facetsForms() {
    return document.querySelectorAll("form.facets__form, facets-form-component form");
  }
  function syncHiddenInputs(tokens) {
    Array.prototype.forEach.call(facetsForms(), function (form) {
      var old = form.querySelectorAll('input[name="' + PARAM + '"]');
      Array.prototype.forEach.call(old, function (n) { n.parentNode.removeChild(n); });
      tokens.forEach(function (t) {
        var inp = document.createElement("input");
        inp.type = "hidden"; inp.name = PARAM; inp.value = t;
        form.appendChild(inp);
      });
    });
  }
  // True when any facets form's fits inputs don't already match `tokens` exactly.
  // Guards the observer: only re-inject when needed, so injecting (a DOM mutation)
  // doesn't retrigger itself into a loop.
  function inputsNeedSync(tokens) {
    var want = tokens.slice().sort().join("\n");
    var forms = facetsForms();
    if (!forms.length) return false;
    for (var i = 0; i < forms.length; i++) {
      var have = Array.prototype.map
        .call(forms[i].querySelectorAll('input[name="' + PARAM + '"]'), function (n) { return n.value; })
        .sort().join("\n");
      if (have !== want) return true;
    }
    return false;
  }

  function currentTokens() {
    var v = readGarage();
    return (v && !dismissed()) ? garageTokens(v) : [];
  }

  function sync() {
    var tokens = currentTokens();
    applyParam(tokens);        // initial / garage-change: apply via the URL
    syncHiddenInputs(tokens);  // persistence across facet/sort changes
    renderChip(readGarage());
  }

  // True when the chip host exists but isn't currently showing the chip while a
  // vehicle is set — i.e. Horizon just re-rendered the section and wiped it.
  function chipNeedsRepaint() {
    var host = chipHost();
    if (!host) return false;
    var want = readGarage() && !dismissed();
    var shown = !host.hidden && host.querySelector(".pl-fitchip");
    return want && !shown;
  }

  // Restore our state after a Horizon re-render: the facets FORM is rebuilt (losing our
  // hidden inputs) and the chip host — inside the re-rendered section — is replaced.
  // Both must run AFTER the DOM swap. We can't use the collection:update/search:update
  // events: facets.js dispatches them synchronously right after kicking off an ASYNC
  // startViewTransition render, so a listener fires BEFORE the new form/host exist and
  // patches nodes that are about to be discarded. A MutationObserver is timing-
  // independent — it fires on the actual swap. Guards keep each patch from re-looping.
  function reconcile() {
    var tokens = currentTokens();
    if (inputsNeedSync(tokens)) syncHiddenInputs(tokens);
    if (chipNeedsRepaint()) renderChip(readGarage());
  }

  // ---------------------------------------------------------------------------
  // Arrive already filtered.
  //
  // Applying the param AFTER the page loads is a second render, every single
  // time, on every collection — RJ: "Right now it does it after every page
  // switch. Unacceptable." The param lives in the URL, so the cure is to put it
  // there BEFORE the request: intercept clicks on collection links and navigate
  // to the filtered URL directly. The server then renders the filtered page
  // first time and there is nothing to correct.
  //
  // Clicks only — hrefs in the DOM are left alone deliberately. Rewriting them
  // would hand crawlers and "copy link address" a vehicle-specific URL for a
  // page that should stay generic.
  //
  // Direct entry, bookmarks and back still land unfiltered and are corrected by
  // sync() below, which is the one case RJ accepted as fine.
  function filteredCollectionUrl(href) {
    var url;
    try { url = new URL(href, window.location.href); } catch (e) { return null; }
    if (url.origin !== window.location.origin) return null;
    if (!/\/collections\//.test(url.pathname)) return null;
    if (url.searchParams.has(PARAM)) return null; // already carries a fitment filter

    var tokens = currentTokens();
    if (!tokens.length) return null;

    // Only navigate pre-filtered when at least one token can actually match.
    // NO product in the catalogue carries a `v:` token — the mirrored metafield
    // holds `s:` and `t:` only (verified across all 712 products, 2026-09-11).
    // A vehicle with no specKey therefore yields v:-only tokens, which match
    // nothing, and sending a shopper straight to an empty collection is worse
    // than sending them to the full one.
    if (!tokens.some(function (t) { return t.indexOf("v:") !== 0; })) return null;

    tokens.forEach(function (t) { url.searchParams.append(PARAM, t); });
    return url.toString();
  }

  document.addEventListener("click", function (e) {
    // Leave modified clicks alone: new tab, download, save — all still generic.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest("a[href]");
    if (!a || a.target === "_blank" || a.hasAttribute("download")) return;

    var next = filteredCollectionUrl(a.getAttribute("href"));
    if (!next) return;
    e.preventDefault();
    window.location.assign(next);
  });

  // Gate on the CHIP HOST, not the facets form. This script is now global (the
  // click interception above has to work from the nav, a PDP, anywhere), and
  // /search carries the same facets-form-component — gating on that would start
  // applying a vehicle filter to search results, which nobody asked for. The chip
  // host is rendered only by main-collection.liquid.
  // ---------------------------------------------------------------------------
  // SEARCH: offered, not applied.
  //
  // Everything above auto-applies the vehicle on a collection. Search gets the
  // opposite treatment on purpose — see the comment in search-results.liquid.
  // The shopper asked a specific question; we say what we could narrow it to and
  // let them choose, in one tap, with a way back.
  function offerHost() { return document.querySelector("[data-pl-fitment-offer]"); }

  function renderOffer() {
    var host = offerHost();
    if (!host) return;
    var vehicle = readGarage();
    var tokens = currentTokens();
    // No vehicle, or one whose tokens could never match anything (v: only, no
    // specKey), means there is nothing honest to offer.
    var offerable =
      vehicle && tokens.some(function (t) { return t.indexOf("v:") !== 0; });
    if (!offerable) { host.hidden = true; host.innerHTML = ""; return; }

    var label = esc(vehicle.label || "vehicle");
    var applied = new URL(window.location.href).searchParams.has(PARAM);
    host.hidden = false;

    if (applied) {
      var appliedText = (host.getAttribute("data-applied-label") || "")
        .replace("__VEHICLE__", label);
      host.innerHTML =
        '<span class="pl-fitchip"><span class="pl-fitchip__label">' + appliedText + "</span></span>" +
        '<button type="button" class="pl-fitchip__out" data-pl-fit-clear>' +
        esc(host.getAttribute("data-clear-label") || "Show all results") + "</button>";
      return;
    }
    var offerText = (host.getAttribute("data-offer-label") || "").replace("__VEHICLE__", label);
    host.innerHTML =
      '<button type="button" class="pl-fitchip pl-fitchip--offer" data-pl-fit-apply>' +
      '<span class="pl-fitchip__label">' + offerText + "</span></button>";
  }

  if (offerHost()) {
    document.addEventListener("click", function (e) {
      var apply = e.target.closest && e.target.closest("[data-pl-fit-apply]");
      var clear = e.target.closest && e.target.closest("[data-pl-fit-clear]");
      if (!apply && !clear) return;
      e.preventDefault();
      applyParam(apply ? currentTokens() : []);
    });
    document.addEventListener("titan:garage:change", renderOffer);
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var host = offerHost();
        if (host && host.hidden && readGarage()) renderOffer();
      }).observe(document.body, { childList: true, subtree: true });
    }
    renderOffer();
  }

  if (chipHost()) {
    // A fresh garage selection re-shows the filter even after a prior dismiss.
    // Just reacts: picking, switching or deactivating a vehicle all arrive here.
    document.addEventListener("titan:garage:change", sync);
    if (window.MutationObserver) {
      new MutationObserver(reconcile).observe(document.body, { childList: true, subtree: true });
    }
    sync();
  }

  window.PitlaneCollectionFitment = { PARAM: PARAM, readGarage: readGarage, garageTokens: garageTokens };
})();
